import { create } from 'zustand'
import type { User } from '@/types/api'

/**
 * El access token vive solo en memoria (nunca en localStorage): un XSS que
 * lea el storage no se lleva la sesion. Al recargar la pagina se pierde y
 * hay que renovarlo con /auth/refresh, que usa la cookie HttpOnly.
 */
interface SessionState {
  status: 'checking' | 'authenticated' | 'anonymous'
  user: User | null
  accessToken: string | null
  setSession: (user: User, accessToken: string) => void
  clear: () => void
}

export const useSessionStore = create<SessionState>((set) => ({
  status: 'checking',
  user: null,
  accessToken: null,
  setSession: (user, accessToken) => set({ status: 'authenticated', user, accessToken }),
  clear: () => set({ status: 'anonymous', user: null, accessToken: null }),
}))

export function getAccessToken(): string | null {
  return useSessionStore.getState().accessToken
}
